export const PROVIDER_ID = 'TIMELY_PROVIDER_ID'
export const USER_ID = 'TIMELY_PROVIDER_USER_ID'

export const TOKEN = 'TIMELY_PROVIDER_APP_TOKEN'
export const REFRESH_TOKEN = 'TIMELY_PROVIDER_APP_REFRESH_TOKEN'
export const TOKEN_CREATED_AT = 'TIMELY_PROVIDER_TOKEN_CREATED_AT'
export const TOKEN_EXPIRES_AT = 'TIMELY_PROVIDER_TOKEN_EXPIRES_AT'

export const AUTO_LOGOUT_MODAL_MINUTES_DELAY = 15
